import { Select,Form } from 'antd'
import React, { useEffect, useState } from 'react'
import { useEntUserListQuery } from '../store/ReactWebSiteApi';

function GetUser(props) {
    const [list,setList] = useState();
    const {data,isSuccess} =useEntUserListQuery({e_id:localStorage.getItem('e_id')})
    useEffect(() => {
        if(isSuccess){
            if(data.Status==='success'){
                
                const newArr = data.Result.map((item) => {
                    const {eu_id,eu_name,euda_ed_id}=item;
                    return item = {value:eu_id,label:eu_name,ed_id:euda_ed_id}
                })
                setList(newArr)
            }
        }
    },[data,isSuccess])
    return (
        <>
            <Form.Item 
                label={props.label} 
                wrapperCol={props.wrapperCol} 
                required={props.required}
                name={props.name}
            >
                <Select 
                    options={list} 
                    onChange={(_,f) => {
                        // console.log(f);
                        props.getUser(f.value,f.label,f.ed_id)
                    }}
                    defaultValue={props.defaultId}
                    placeholder={props.defaultId}
                    style={props.style}
                />
            </Form.Item>
        </>
    )
}

export default GetUser